import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Import necessary components
import Navbar from "./components/Navbar";
import Home from "./Pages/Home";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import About from "./Pages/About";
import Institutions from "./Pages/Institutions";
import Vision from "./Pages/Vision";
import News from "./Pages/News";
import Contact from "./Pages/Contact";
import Gallery from "./Pages/Gallery";


function App() {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/institutions" element={<Institutions />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </React.Fragment>
  );
}

export default App;
